import { AnimatePresence, motion } from 'framer-motion'

const variants = {
  enter: (direction: number) => {
    return {
      y: direction > 0 ? '100%' : '-100%',
    }
  },
  center: {
    zIndex: 1,
    y: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      y: direction < 0 ? '110%' : '-110%',
    }
  },
}

export const DateTitle = ({ dateTitle, direction }: { direction: number; dateTitle: string }) => {
  // dateTitle = dateTitle + dateTitle

  return (
    <motion.div
      layout
      className="relative -ml-4 flex items-center overflow-y-hidden rounded bg-orange-300 pl-4 text-2xl "
    >
      <div className="-ml-4 overflow-hidden text-ellipsis text-nowrap px-4 opacity-0">
        {dateTitle}
      </div>

      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={dateTitle}
          initial="enter"
          animate="center"
          exit="exit"
          custom={direction}
          variants={variants}
          transition={{
            type: 'just',
          }}
          className="absolute left-0 right-0 overflow-hidden text-ellipsis text-nowrap px-4"
        >
          {dateTitle}
        </motion.div>
      </AnimatePresence>
    </motion.div>
  )
}
